import './AddNote.scss';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import { useEffect, useState } from 'react';
import Notes from '../../api/controllers/Notes/Notes';
import Error from '../Error/Error';
import { getContextString } from './AddNoteUtils';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Button from '../Button/Button';

// Common AddNote Component
const AddNote = ({
  edit,
  note,
  movementType,
  modelName,
  movementId,
  setModalOpen,
  refetchNotes,
}) => {
  const [error, setError] = useState();
  const [types, setTypes] = useState([]);
  const [title, setTitle] = useState();
  const [type, setType] = useState();
  const [content, setContent] = useState();
  const [firstOption, setFirstOption] = useState({ id: 0, name: '' });
  const [loading, setLoading] = useState();

  const createNote = () => {
    const params = {
      parentType: modelName,
      parentId: movementId,
      noteTypeId: type,
      title: title,
      content: content,
    };
    setLoading(true);
    Notes.create(params)
      .then(() => {
        refetchNotes();
        setModalOpen(false);
        setLoading(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
        setLoading(false);
      });
  };

  const updateNote = () => {
    const params = {
      parentType: note.parentType,
      parentId: note.parentId,
      noteTypeId: type,
      title: title,
      content: content,
    };
    setLoading(true);
    Notes.update(note.id, params)
      .then(() => {
        refetchNotes();
        setModalOpen(false);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const getTypes = () => {
    setLoading(true);
    Notes.getTypes({
      context: getContextString(movementType),
    })
      .then(response => {
        setTypes(response.items);
        setLoading(false);
        if (!edit) {
          setType(response.items[0].id);
        }
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getTypes();
    if (edit) {
      setTitle(note.title);
      setFirstOption(note.noteType);
      setType(note.noteType.id);
      setContent(note.content);
    }
  }, []);

  return (
    <div className="add_note_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="add_note_row">
        <div className="add_note_title">
          <div className="label_block">Title</div>
          <Input value={title} setValue={setTitle} />
        </div>
        <div className="add_note_type">
          <div className="label_block">Type</div>
          <select onChange={e => setType(e.target.value)} data-testid="note_type_selector">
            {edit && firstOption.name != '' && (
              <option value={firstOption.id} selected disabled hidden>
                {firstOption.name}
              </option>
            )}
            {types?.map(type => (
              <option key={type.id} value={type.id} data-testid={`note_type_option_${type.id}`}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <textarea
        data-testid="note_content_textarea"
        className="add_note_content"
        value={content}
        onChange={e => setContent(e.target.value)}
      />
      <Button
        className="add_note_button"
        onClick={edit ? () => updateNote() : () => createNote()}
        label={`${edit ? 'Update' : 'Create'} Note`}
      />
    </div>
  );
};

AddNote.propTypes = {
  edit: PropTypes.bool,
  note: PropTypes.object,
  movementType: PropTypes.string,
  modelName: PropTypes.string,
  movementId: PropTypes.number,
  refetchNotes: PropTypes.func,
  setModalOpen: PropTypes.func,
};

export default AddNote;
